import { useMutation } from '@tanstack/vue-query';
import { getApi } from '../api';

export type DialogContentBlock =
    | { type: 'text'; text: string }
    | { type: 'tool_call'; id: string; name: 'ui_suggestion_card'; arguments: { suggestion_ids: string[] } }
    | { type: 'tool_call'; id: string; name: 'ui_removal_card'; arguments: { removal_ids: string[] } }
    | { type: 'tool_result'; tool_call_id: string; content: string };

export type DialogMessage = {
    role: 'user' | 'assistant' | 'tool';
    content: DialogContentBlock[];
};

export type PostAccountDialogPayload = {
    messages: DialogMessage[];
    model: string;
    files?: any;
    user_id?: number;
};

export default (accountId: number) => useMutation({
    mutationFn: ({ messages, model, files, user_id }: PostAccountDialogPayload) => {
        const { api, baseURL } = getApi();
        const payload: any = { messages, model };
        if (files && files.length > 0) {
            payload.files = files;
        }
        if (user_id) {
            payload.user_id = user_id;
        }
        return (api as any).post(`/api/v2/accounts/${accountId}/dialogs/`, payload, { baseURL, useOriginalToken: true }).then(res => res.data.data)
    },
})
